// Youssef Selkani
// 2019

import React, { Component } from 'react'
import { BrowserRouter as Router, Route } from 'react-router-dom'
import fire from './config/Fire'
import './App.css'
import { createBrowserHistory } from 'history'
// import { ParallaxProvider } from 'react-scroll-parallax'
import { Sidebar, Responsive, Container } from 'semantic-ui-react'
import DropdownMenu from './components/DropdownMenu'
import SideBarMenu from './components/SideBarMenu'
import SideBarMenuAuth from './components/SideBarMenuAuth'

// Routes
import Home from './routes/Home'
import Dashboard from './routes/Dashboard'
import Download from './routes/Download'
import WordPress from './routes/WordPress'
import ManageWordPress from './routes/ManageWordPress'
import WooCommerce from './routes/WooCommerce'
import ManageWooCommerce from './routes/ManageWooCommerce'
import Pricing from './routes/Pricing'
import About from './routes/About'
import Blog from './routes/Blog'
import Sheets from './routes/Sheets'

import ManageSheet from './routes/ManageSheet'
import PublicSheet from './routes/PublicSheet'

// Auth

import LogIn from './routes/LogIn'
import SignUp from './routes/SignUp'
import ResetPassword from './routes/ResetPassword'
import UserMgmt from './routes/UserMgmt'
import AccountSettings from './routes/AccountSettings'

// Blog
import WooCommerceTuto from './routes/blog/WooCommerceTuto'

// Other
import Terms from './routes/Terms'
import Privacy from './routes/Privacy'
import Redirect from './routes/Redirect'
import Contact from './routes/Contact'
import Thanks from './routes/Thanks'

import AdMob from './routes/AdMob'
// Components
import Footer from './components/Footer'

// Other
import AppStyle from './routes/AppStyle'
import Onboarding from './routes/Onboarding'
import StorageTuto from './routes/blog/StorageTuto'
import PoweredBy from './components/PoweredBy'

// Maker
import MakerEdit from './routes/MakerEdit'
import Maker from './routes/Maker'

import Announcement from 'react-announcement'
import objects from './assets/objects.png'
import WebSheet from './components/WebSheet'
import Navigation from './routes/Navigation'

const history = createBrowserHistory()

class App extends Component {
  constructor (props) {
    super(props)
    this.handleShowClick = this.handleShowClick.bind(this)
    this.state = {
      error: null,
      loading: true,
      maintenance: false,
      unstable: false,
      visible: false
    }
  }

  handleHideClick = () => this.setState({ visible: !this.state.visible })
  handleShowClick = () => this.setState({ visible: !this.state.visible })
  handleSidebarHide = () => this.setState({ visible: !this.state.visible })

  componentDidMount = () => {
    fire.auth().onAuthStateChanged((user) => {
      if (user) {
        fire.auth()
        this.setState({
          loggedIn: true,
          loading: false,
          email: user.email
        })
      } else {
        this.setState({ loggedIn: false, loading: false })
      }
    })
  }

  componentWillMount = (props) => {
    if (window.location.pathname.includes('public')) {
      this.setState({ readonly: true })
    }
  }

  handleOnUpdate = (e, { width }) => this.setState({ width })

  render () {
    let { readonly, loggedIn, visible, loading } = this.state
    return (
      <Router history={history}>
        {!readonly && (
          <DropdownMenu
            {...this.state}
            handleShowClick={this.handleShowClick.bind(this)}
            handleHideClick={this.handleHideClick.bind(this)}
          />
        )}
        <Responsive fireOnMount onUpdate={this.handleOnUpdate}>
          <Sidebar.Pushable>
            <Sidebar
              animation='overlay'
              icon='labeled'
              onHide={this.handleSidebarHide}
              vertical='true'
              direction='right'
              visible={visible}
              style={{
                backgroundColor: '#000',
                maxWidth: this.state.width >= Responsive.onlyComputer.minWidth ? '35%' : '100%',
                borderColor: '#000'
              }}>
              {!loggedIn && !loading && <SideBarMenu />}
              {loggedIn && !loading && <SideBarMenuAuth />}
            </Sidebar>

            <Sidebar.Pusher dimmed={visible}>

              <Route path='/' exact render={() => <Home {...this.state} />} />
              {/* Auth */}
              <Route path='/login' component={LogIn} />
              <Route path='/signup' component={SignUp} />
              <Route path='/resetpassword' component={ResetPassword} />
              {/* User */}
              <Route path='/dashboard' component={Dashboard} {...this.state} />
              <Route path='/download' component={Download} />
              <Route path='/settings' component={AccountSettings} />
              <Route path='/manage/auth' exact component={UserMgmt} />
              <Route path='/manage/admob' exact component={AdMob} />
              {/* WordPress */}
              <Route path='/wordpress' component={WordPress} />
              <Route path='/manage/wordpress' exact component={ManageWordPress} />
              {/* WooCommerce */}
              <Route path='/woocommerce' component={WooCommerce} />
              <Route path='/manage/woocommerce' exact component={ManageWooCommerce} />
              {/* Sheets */}
              <Route path='/sheets' component={Sheets} />
              <Route path='/manage/sheet/:sheetid' component={ManageSheet} />
              <Route path='/public/sheet/:sheetid/' component={PublicSheet} />
              {/* Blog */}
              <Route path='/blog' exact component={Blog} />
              <Route path='/blog/woocommerce-tuto' exact component={WooCommerceTuto} />
              <Route path='/blog/firebase-storage-tuto' exact component={StorageTuto} />
              {/* Maker */}
              <Route path='/maker' exact component={Maker} />
              <Route path='/edit/screen/:screenid' exact component={MakerEdit} />
              <Route path='/app/style' component={AppStyle} />
              <Route path='/maker/navigation' component={Navigation} />
              {/* Other */}
              <Route path='/contact' component={Contact} />
              <Route path='/about' component={About} />
              <Route path='/pricing' component={Pricing} />
              <Route path='/terms' component={Terms} />
              <Route path='/onboarding' component={Onboarding} />
              <Route path='/thanks' component={Thanks} />
              <Route path='/privacy' component={Privacy} />
              <Route path='/sheetv3' component={Home} />
              <Route path='/websheet' component={WebSheet} />
            </Sidebar.Pusher>
          </Sidebar.Pushable>
          {!readonly && <Footer {...this.state} />}
          {readonly && <PoweredBy {...this.state} />}
          {/* <Announcement
            title='What features you wish Murkstom had?'
            subtitle='Please let us know via our road map or contact form.'
            daysToLive={3}
            secondsBeforeBannerShows={5}
            imageSource={objects}
            closeIconSize={20}
          /> */}
        </Responsive>
      </Router>
    )
  }
}

export default App
